import type { RouteObject } from "react-router";
import { lazyScreen } from "../../app/lazyScreen";
import { routePaths } from "../../app/navigation";

/**
 * Creates the routes of „Einrichtung“ (F-72): the overview at `/setup` and one page per step of
 * the assistant at `/setup/{step}`. The caller puts them behind the guard of the master data.
 *
 * @returns The route.
 */
export function setupRoute(): RouteObject {
  const route: RouteObject = {
    path: routePaths.setup,
    children: [
      {
        index: true,
        lazy: lazyScreen(
          () => import("./setupScreens"),
          (m) => m.SetupPage,
        ),
      },
      {
        path: ":step",
        lazy: lazyScreen(
          () => import("./setupScreens"),
          (m) => m.SetupStepPage,
        ),
      },
    ],
  };

  return route;
}
